import { Component, Inject, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { Property } from "@app/models/Property";
import { PaymentHistory } from "@app/models/PaymentHistory";
import {
    ExpandedPaymentHistoryDetailComponent
} from "@app/components/expandedPaymentHistoryDetail/expandedPaymentHistoryDetail.component";
import { PaymentHistoryCancelService } from "@app/services/PaymentHistoryCancel.service";

@Component({
    selector: 'app-payment-history',
    template: require('./paymentHistory.directive.html'),
})
export class PaymentHistoryDirectiveComponent implements OnInit, OnChanges {

    @Input() paymentHistory: PaymentHistory[]
    @Input() property: Property
    @Input() limit: number

    private sortedAndLimitedPaymentHistory: PaymentHistory[];

    constructor(
        @Inject(ExpandedPaymentHistoryDetailComponent) private historyDetailService: ExpandedPaymentHistoryDetailComponent,
        @Inject(PaymentHistoryCancelService) private paymentHistoryService: PaymentHistoryCancelService
    ) { }

    cancel(payment) {
        this.paymentHistoryService.confirmCancelPayment(payment, this.property)
    }

    openDetail(paymentHistory: PaymentHistory) {
        this.historyDetailService.loadExpandedPaymentHistoryDetail(paymentHistory);
    }

    ngOnInit(): void {
        this.sortAndLimitHistory(this.paymentHistory);
    }

    ngOnChanges(changes: SimpleChanges): void {

        if(changes['paymentHistory'] && !changes['paymentHistory'].isFirstChange()) {
            this.sortAndLimitHistory(this.paymentHistory);
        }

    }

    private sortAndLimitHistory(paymentHistory: PaymentHistory[]) {
        this.sortedAndLimitedPaymentHistory = [];

        if(!paymentHistory) {
            return;
        } else if(paymentHistory.length === 0) {
            return;
        } else if(paymentHistory.length === 1) {
            this.sortedAndLimitedPaymentHistory = paymentHistory;
            return;
        }

        // first sort the array
        let sortedCopy: PaymentHistory[] = this.paymentHistory.sort((a, b) => {

            let yearResult = b.date.year - a.date.year;

            if (yearResult !== 0) {
                return yearResult;
            }

            let monthResult = b.date.month - a.date.month;

            if (monthResult !== 0) {
                return monthResult;
            }

            let dayResult = b.date.day - a.date.day;

            if (dayResult !== 0) {
                return dayResult;
            }

            return b.id - a.id;
        });

        // now take the first entries, up to limit
        if(sortedCopy.length > this.limit) {
            this.sortedAndLimitedPaymentHistory = sortedCopy.slice(0, this.limit);
        } else {
            this.sortedAndLimitedPaymentHistory = sortedCopy;
        }

    }

}



